// Wait for the DOM to be completely loaded
document.addEventListener("DOMContentLoaded", () => {
    // Select all checkin anchor elements
    const locationPageElements = document.querySelectorAll('a.btn.btn--primary.btn-hard.store-details__check-in.check-in--link.js-check-in.webCheckIn')
    const storeLocatorElements = document.querySelectorAll('a.btn.btn--primary.location__check-in.js-check-in.webCheckIn')

    const checkInElements = locationPageElements.length > 0 ? locationPageElements : storeLocatorElements

    // Add click event listener to each link
    checkInElements.forEach(link => {
      link.addEventListener("click", function(event) {
        // Prevent the default action of the link
        event.preventDefault();
        event.stopImmediatePropagation();
        
        // Get the data-url attribute from the clicked link
        const iframeUrl = this.getAttribute("data-url") || this.getAttribute("data-bs-url");
  
        // Get the checkin container
        const container = document.querySelector('div#checkInContainer');
  
        // Get the checkin Iframe
        const iframe = document.querySelector('iframe#checkInFrame');
  
        // Update the src attribute and make it visible
        iframe.setAttribute("src", iframeUrl);
        if (container.classList.contains('visible')) {
          //container.classList.remove('visible');
          document.body.style.overflow = "auto";
        } else {
          container.classList.add('visible');
          document.body.style.overflow = "hidden";
        }
      });
    });
    
    document.querySelector('div#checkInReturnButton').addEventListener("click", function(event){
        // Prevent the default action of the link
        event.preventDefault();
        
        // Get the checkin container
        const container = document.querySelector('div#checkInContainer');
  
        // Get the checkin Iframe
        const iframe = document.querySelector('iframe#checkInFrame');
  
        // Update the src attribute and make it visible
        if (container.classList.contains('visible')) {
          document.body.style.overflow = "auto";
          container.classList.remove('visible');
          iframe.setAttribute("src", 'about:blank');
        }
    });
            
    // Listen for message from the parent window
    window.addEventListener('message', function(event) {
      // Validate the origin of the message
      const allowedOrigins = ['https://checkin.tommyguns.com'];
    
      if (allowedOrigins.includes(event.origin)) {
        // Handle the message
        if (event.data === 'wci-close-iframe') {
          // Perform your action here, e.g., close the iframe
          // Get the checkin container
          const container = document.querySelector('div#checkInContainer');
    
          // Get the checkin Iframe
          const iframe = document.querySelector('iframe#checkInFrame');
    
          // Update the src attribute and make it visible
          iframe.setAttribute("src", 'about:blank');
          if (container.classList.contains('visible')) {
            container.classList.remove('visible');
          } else {
            container.classList.add('visible');
          }
        }
      }
    });
  
  });